import moment from "moment";

const url = process.env.REACT_APP_API_URL + "/api/energy_consumption";
const quantityToApiModel = (quantity) => {
  switch (quantity) {
    case "consumption":
      return "EnergyConsumptionModel";
    case "emission":
      return "CarbonDioxideEmissionModel";
    case "price":
      return "PricePerformanceModel";
  }
};
const dateToApiDateString = (date) => moment(date).format("YYYY-MM-DD");
export default {
  daily: {
    list: ({ endDate, projectId, quantity, startDate }) => {
      const modelName = quantityToApiModel(quantity);
      const startInterval = dateToApiDateString(startDate);
      const endInterval = dateToApiDateString(endDate);
      return `${url}/get_daily_data/?project_id=${projectId}&model_name=${modelName}&start_interval=${startInterval} 00:00:00&end_interval=${endInterval} 23:59:59`;
    },
  },
  hourly: {
    list: ({ endDate, projectId, quantity, startDate }) => {
      const modelName = quantityToApiModel(quantity);
      const startInterval = dateToApiDateString(startDate);
      const endInterval = dateToApiDateString(endDate);
      return `${url}/get_hourly_data/?project_id=${projectId}&model_name=${modelName}&start_interval=${startInterval} 00:00:00&end_interval=${endInterval} 23:59:59`;
    },
  },
  monthly: {
    list: ({ endDate, projectId, quantity, startDate }) => {
      const modelName = quantityToApiModel(quantity);
      const startInterval = dateToApiDateString(startDate);
      const endInterval = dateToApiDateString(endDate);
      return `${url}/get_monthly_data/?project_id=${projectId}&model_name=${modelName}&start_interval=${startInterval} 00:00:00&end_interval=${endInterval} 23:59:59`;
    },
  },
};
